import {
  IS_MOBILE,
  CURRENT_THEME,
  OPEN_DEPOSIT_TAB,
  NAVIGATION_OPENED,
  NAVIGATION_CLOSED,
  CLOSE_DEPOSIT_TAB,
  NAVIGATION_SECTION_OPENED,
  NAVIGATION_SECTION_CLOSED,
  SET_METAMASK_NETWORK_ERROR,
} from 'store/actions/actionTypes';
import { loadState } from 'utils';

const defaultState = {
  theme: loadState('theme') || 'main',
  isMobile: false,
  navigationIsOpened: false,
  depositTabIsActive: false,
  navigationSection: {
    games: true,
  },
  metamaskIsWrongNetwork: false,
};

function uiStateReducer(state = defaultState, action) {
  switch (action.type) {
    case IS_MOBILE:
      return {
        ...state,
        isMobile: action.payload,
      };
    case NAVIGATION_OPENED:
      return {
        ...state,
        navigationIsOpened: true,
      };
    case CURRENT_THEME:
      return {
        ...state,
        theme: action.payload,
      };
    case NAVIGATION_CLOSED:
      return {
        ...state,
        navigationIsOpened: false,
      };
    case NAVIGATION_SECTION_OPENED:
      return {
        ...state,
        navigationSection: {
          ...state.navigationSection,
          [action.payload]: true,
        },
      };
    case NAVIGATION_SECTION_CLOSED:
      return {
        ...state,
        navigationSection: {
          ...state.navigationSection,
          [action.payload]: false,
        },
      };
    case OPEN_DEPOSIT_TAB:
      return {
        ...state,
        depositTabIsActive: true,
      };
    case CLOSE_DEPOSIT_TAB:
      return {
        ...state,
        depositTabIsActive: false,
      };
    case SET_METAMASK_NETWORK_ERROR:
      return {
        ...state,
        metamaskIsWrongNetwork: action.payload,
      };
    default:
      return state;
  }
}

export default uiStateReducer;
